class CreditCard {
  constructor(props) {
    Object.assign(this, props);
  }
}

export default CreditCard;